<template>
  <div class="app">
    <!-- Navbar-->
    <Nav />
    <!-- Sidebar menu-->
    <div class="app-sidebar__overlay" data-toggle="sidebar"></div>
    <Side />
    <main class="app-content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import Nav from "./layouts/Nav";
import Side from "./layouts/Side";
export default {
  components: {
    Nav,
    Side,
  },
};
</script>

<style>
</style>  